import { RgPipes } from "./index9.js";
import { RunPipeline } from "./index182.js";
import { GetAllBones, RG_TYPE } from "@project-rouge/rg-core";
import { getRgObjectsOfType as getRgObjectsOfType$1 } from "@project-rouge/rg-three";
function rebuildFromSkeleton({ obj, aggProps, buildingIds }) {
	const buildings = getRgObjectsOfType$1(obj, RG_TYPE.Building).filter((b) => buildingIds.includes(b.uuid));
	buildings.forEach((b) => {
		b.children = [];
	});
	buildings.forEach((b) => {
		GetAllBones(b.data.anatomy).forEach((bone) => {
			bone.muscles = [];
		});
	});
	return RunPipeline({
		obj,
		aggProps,
		from: RgPipes.AddMuscles,
		buildingIds
	});
}
export { rebuildFromSkeleton };

//# sourceMappingURL=index203.js.map